<script>
import Vue from 'vue';
import {mapState, mapActions, mapGetters} from 'vuex';

export default Vue.extend({
    computed: {
        ...mapState({
            user: state => state.auth.user,
            contract: state => state.contract.contract.item
        }),
        ...mapGetters({
            contractProgressObject: 'contract/contractProgressObject'
        })
    },
    methods: {
        ...mapActions({
            contractManagementSendEmailSupplier: 'contract/contractManagementSendEmailSupplier'
        })
    }
});
</script>
<template>
    <div class="contract-form-email">
        <transition name="fade" mode="out-in">
            <div v-if="contractProgressObject.all && user.contractManager" class="contract-form-email__content">
                <div class="contract-form-email__left">{{ $t('contract.form.complete') }}</div>
                <div class="contract-form-email__right">
                    <button v-if="!contract || !contract.readyForSupplier"
                            class="contract-form-email__btn"
                            @click="contractManagementSendEmailSupplier">
                        {{ $t('contract.form.email') }}
                    </button>
                    <span v-if="contract && contract.readyForSupplier" class="contract-form-email__text">
                        {{ contract.readyForSupplier | moment("DD/MM/Y\, HH:mm") }}
                    </span>
                </div>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractFormEmail/ContractFormEmail.vue